import { EVENT_CALENDAR_URL } from './calendar';

const NUM_PAGE = 12;

const MENU = ['News', 'Product', 'Technology', 'Company'];

const SUBMENU = {
  News: ['Conjunction Briefing', 'Building Trust'],
  Product: ['Product'],
  Technology: ['Technology', 'Resources'],
  Company: ['Team',  'Partners', 'Contact'],
};

const PRODUCT_LINKS = [
  {
    key: 'Platform',
    url: 'https://platform.spacemap42.com/',
  },
  {
    key: 'SpaceTube',
    url: 'https://tube.spacemap42.com/',
    isNew: true,
  },
  {
    key: 'SpaceCalendar',
    url: EVENT_CALENDAR_URL,
  },
];

export { NUM_PAGE, MENU, SUBMENU, PRODUCT_LINKS };
